/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, ButtonBase, Drawer, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import logo_oscuro from '../../Recursos/logo_color.svg'
import {Close, Menu} from '@mui/icons-material'
import {useState} from "react";
import {REDES, SECCIONES} from "../../Constantes";
import {useNavigate} from "react-router";
import {irUrl} from "../../Utilidades/irUrl";
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";

const BarraCell = ({negro}) => {
    const navigate = useNavigate()
    const {ir} = useIrRuta()
    const [open, setOpen] = useState(false)

    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: negro ? '#000' : '#00000000', px: 3, py: 3}}
        >

            <Box>
                <img
                    onClick={() => navigate('/Home')}
                    src={logo_oscuro} width={160} height={'auto'} style={{marginTop: 0}}/>
            </Box>


            <Box>
                {/*<IconButton
                   // onClick={(e) => abrirMenu(e)}
                    sx={{backgroundColor: '#fff', mr: 1}}
                >
                    <WhatsApp sx={{fill: theme.palette.primary.main}}/>
                </IconButton>*/}

                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{backgroundColor: theme.palette.primary.main}}
                >
                    <Menu sx={{fill: '#fff'}}/>
                </IconButton>
            </Box>


            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>




                    {SECCIONES.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        ir(item)
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>{item}</Typography>
                            </ButtonBase>
                        </Grid>
                    ))}


                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 50}}>
                        <img src={logo} width={180} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 4}}>
                        {REDES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                        sx={{backgroundColor: theme.palette.secondary.main}}
                                    >
                                        <img src={item.img} width={28} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell